'use client';

import map from 'lodash/map';
import { useMediaQuery } from 'usehooks-ts';
import Heading from '@/components/shared/Heading';
import * as Carousel from '@/components/ui/Carousel';
import { DownloadCard } from '@/components/ui/DownloadCard/DownloadCard';

type DownloadSectionProps = {
  title?: string;
  documents?: {
    id: string;
    title?: string;
    date?: Date;
    media?: {
      name: string;
      url: string;
    };
  }[];
};

export const DownloadSection = ({ title, documents }: DownloadSectionProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)');

  return (
    <section className="form w-full bg-grey-100 pb-12 lg:pb-20">
      <div className="container m-auto px-6">
        <Heading
          variant="h1"
          asChild
          className="my-12 text-center font-publico text-blue-500 lg:my-20 lg:text-[32px] 2xl:text-[2.5rem]"
        >
          <h2>{title}</h2>
        </Heading>
      </div>
      <div className="mx-auto w-full lg:max-w-[912px] xl:max-w-[1184px] 2xl:max-w-[1280px]">
        <Carousel.Root
          className="w-full pl-6 lg:pl-0"
          opts={{
            align: 'start'
          }}
        >
          <Carousel.Content className="-ml-0">
            {map(documents, (document) => (
              <Carousel.Item
                key={document.id}
                className="basis-[280px] lg:basis-[456px] xl:basis-[384px] 2xl:basis-[416px]"
              >
                <DownloadCard
                  filePath={document.media?.url}
                  fileName={document.media?.name}
                  title={document.title}
                  date={document.date}
                />
              </Carousel.Item>
            ))}
          </Carousel.Content>
          <div
            data-visible={!isMobile}
            className="hidden justify-center gap-4 pt-10 data-[visible=false]:hidden lg:flex"
          >
            <Carousel.PreviousButton />
            <Carousel.NextButton />
          </div>
        </Carousel.Root>
      </div>
    </section>
  );
};
